import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import searchResultToCallDetails from 'utils/searchResultToCallDetails';
import FileUploadActions from 'actions/files/FileUploadActions';
import CallActions from 'actions/CallActions';
import {OrderedSet, Record, List, Map} from 'immutable';

const State = Record({
  // Recently fetched calls
  calls: OrderedSet(),
  isSearching: false,
  wasErrorSearching: false,
  // Maps are keyed by callId
  partiallyHydratedCalls: Map(),
  partiallyHydratedCallsLoading: Map(),
  partiallyHydratedCallsError: Map(),
  teamNameByCall: Map(),
  // these get set when we drilldown from the dashboard into lists of calls.
  // once done, we need to manually clear them.
  backUrl: undefined,
  backText: undefined,
  limitWarning: undefined,
  drilldownCalls: undefined,
});

// Similar to FileuploadStore but converts odd format to CallDetails
@immutableStore
class CallStore {
  constructor() {
    this.state = new State();
    this.bindActions(FileUploadActions);
    this.bindActions(CallActions);
  }
  search() {
    this.setState({
      isSearching: true,
      wasErrorSearching: false,
    });
  }
  searchSuccess(data) {
    // a bit hacky but some of these call search actions don't
    // unwrap the data property from the response object, so do it here
    // TODO clean this up if we ever get around to cleaning up some of these
    // redundant stores
    if (!data.results) {
      data = data.response.data;
    }
    const calls = List(data.results.map(searchResultToCallDetails));
    this.setState({
      calls: this.state.calls.concat(calls),
      isSearching: false,
    });
  }
  searchError() {
    this.setState({
      isSearching: false,
      wasErrorSearching: true,
    });
  }
  getPartiallyHydratedCalls(callIds) {
    this.setState({
      partiallyHydratedCallsLoading: callIds.reduce(
        (mem, callId) => mem.set(callId, true),
        this.state.partiallyHydratedCallsLoading
      ),
      partiallyHydratedCallsError: callIds.reduce(
        (mem, callId) => mem.set(callId, false),
        this.state.partiallyHydratedCallsError
      ),
    });
  }
  getPartiallyHydratedCallsSuccess(res) {
    const calls = List(res.data.results.map(result => searchResultToCallDetails(result)));
    this.setState({
      partiallyHydratedCalls: this.state.partiallyHydratedCalls.merge(
        calls.groupBy(call => call.id).map(v => v.get(0))
      ),
      partiallyHydratedCallsLoading: calls.reduce(
        (mem, call) => mem.set(call.id, false),
        this.state.partiallyHydratedCallsLoading
      ),
    });
  }
  getPartiallyHydratedCallsError(callIds) {
    this.setState({
      partiallyHydratedCallsLoading: callIds.reduce(
        (mem, call) => mem.set(call.id, false),
        this.state.partiallyHydratedCallsLoading
      ),
      partiallyHydratedCallsError: callIds.reduce(
        (mem, callId) => mem.set(callId, true),
        this.state.partiallyHydratedCallsError
      ),
    });
  }

  fetchCallTeamNameSuccess([fileUploadId, result]) {
    this.setState({
      teamNameByCall: this.state.teamNameByCall.set(fileUploadId, result),
    });
  }

  setDrilldown([backUrl, backText, limitWarning, drilldownCalls]) {
    this.setState({
      backUrl,
      backText,
      limitWarning,
      drilldownCalls,
    });
  }

  clearDrilldown() {
    this.setState({
      backUrl: undefined,
      backText: undefined,
      limitWarning: undefined,
      drilldownCalls: undefined,
    });
  }
}

export default alt.createStore(CallStore);
